export const environment = {
  production: false,
  apiBase: 'https://api.mmaptcontrol.dev',
  auth: {
    userPoolId: 'ap-southeast-2_OuqOXUpc1',
    clientId: '7aqsk1hnkn8vkg77hi8urmgc10',
    region: 'ap-southeast-2',
    scopes: [
      'email',
      'openid',
      'profile',
      'aws.cognito.signin.user.admin',
    ],
    cookieDomain: '.mmaptcontrol.dev',
    redirectSignIn: 'https://mmaptcontrol.dev/signin',
    redirectSignOut: 'https://mmaptcontrol.dev/signout',
    responseType: 'code',
    domain: 'mmapt-dev.auth.ap-southeast-2.amazoncognito.com',
  },
  s3Base: 'https://assets.mmaptcontrol.dev/',
  cognitoGroups: {
    superAdmins: 'superAdmins-b7a5b14',
    localSetupClientUsers: 'localSetupClientUsers-dbdb6c3',
    localClientUsers: 'localClientUsers-e50af2c',
    imageryTeamMembers: 'imageryTeamMembers-8ae8dea',
    skyTeamMembers: 'skyTeamMembers-a2eb141',
  },
};
